export interface IDonorUpdate {
    id: number,
    firstName: string,
    lastName: string, 
    dob: string
}